import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AngularMaterialModule } from '@app/shared/angular-material.module';

import { BreadcrumsComponent } from './components/breadcrums/breadcrums.component';
import { CounterLessAddComponent } from './components/counter-less-add/counter-less-add.component';
import { FieldsNumberSeparateComponent } from './components/fields-number-separate/fields-number-separate.component';
import { FormDataBillingFieldsComponent } from './components/form-data-billing-fields/form-data-billing-fields.component';
import { FormDataBillingComponent } from './components/form-data-billing/form-data-billing.component';
import { GenericDialogComponent } from './components/generic-dialog/generic-dialog.component';
import { GenericGridComponent } from './components/generic-grid/generic-grid.component';
import { ModalCarryInfoPayOdcComponent } from './components/modal-carry-info-pay-odc/modal-carry-info-pay-odc.component';
import { ModalConfirmPrintComponent } from './components/modal-confirm-print/modal-confirm-print.component';
import { ModalDatailPayOdcComponent } from './components/modal-datail-pay-odc/modal-datail-pay-odc.component';
import { ModalGenerateGuideComponent } from './components/modal-generate-guide/modal-generate-guide.component';
import { ModalGenericInfComponent } from './components/modal-generic-inf/modal-generic-inf.component';
import { ModalPayOdcComponent } from './components/modal-pay-odc/modal-pay-odc.component';
import { ModalPaymentSummaryComponent } from './components/modal-payment-summary/modal-payment-summary.component';
import { ModalPoliticsComponent } from './components/modal-politics/modal-politics.component';
import { ModalTerminosUsoComponent } from './components/modal-terminos-uso/modal-terminos-uso.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { ShowValidationsInputPasswordComponent } from './components/show-validations-input-password/show-validations-input-password.component';
import { ToggleSliderComponent } from './components/toggle-slider/toggle-slider.component';
import { CurrencyFieldDirective } from './directives/currency-field.directive';
import { NumericFieldDirective } from './directives/numeric-field.directive';
import { AlphanumericFieldDirective } from './directives/alphanumeric-field.directive';
import { AppPermissionDirective } from './directives/app-permission.directive';
import { MaxRangeDirective } from './directives/max-date-range.directive';
import { ModalDownlandPrintComponent } from './components/modal-downland-print/modal-downland-print.component';
import { AppProfileDirective } from "./directives/app-profile.directive";
import { CounterLessAddHomeComponent } from './components/counter-less-add-home/counter-less-add.home.component';

@NgModule({
  declarations: [
    GenericDialogComponent,
    GenericGridComponent,
    PageNotFoundComponent,
    BreadcrumsComponent,
    CurrencyFieldDirective,
    FormDataBillingComponent,
    FormDataBillingFieldsComponent,
    ModalGenericInfComponent,
    CounterLessAddComponent,
    ToggleSliderComponent,
    ShowValidationsInputPasswordComponent,
    FieldsNumberSeparateComponent,
    ModalPoliticsComponent,
    ModalPaymentSummaryComponent,
    ModalPayOdcComponent,
    ModalDatailPayOdcComponent,
    ModalCarryInfoPayOdcComponent,
    ModalTerminosUsoComponent,
    ModalConfirmPrintComponent,
    ModalGenerateGuideComponent,
    AlphanumericFieldDirective,
    NumericFieldDirective,
    AppPermissionDirective,
    MaxRangeDirective,
    ModalDownlandPrintComponent,
    AppProfileDirective,
    CounterLessAddHomeComponent
  ],
  imports: [CommonModule, AngularMaterialModule, FormsModule, ReactiveFormsModule, RouterModule],
  exports: [
    GenericDialogComponent,
    GenericGridComponent,
    PageNotFoundComponent,
    BreadcrumsComponent,
    CurrencyFieldDirective,
    FormDataBillingComponent,
    FormDataBillingFieldsComponent,
    ModalGenericInfComponent,
    CounterLessAddComponent,
    ToggleSliderComponent,
    ShowValidationsInputPasswordComponent,
    FieldsNumberSeparateComponent,
    ModalPoliticsComponent,
    ModalPaymentSummaryComponent,
    ModalPayOdcComponent,
    ModalDatailPayOdcComponent,
    ModalCarryInfoPayOdcComponent,
    ModalTerminosUsoComponent,
    ModalConfirmPrintComponent,
    ModalGenerateGuideComponent,
    AlphanumericFieldDirective,
    NumericFieldDirective,
    AppPermissionDirective,
    MaxRangeDirective,
    ModalDownlandPrintComponent,
    AppProfileDirective,
    CounterLessAddHomeComponent
  ]
})
export class SharedModule {}
